module.exports = __webpack_public_path__ + "app-static/img/05.951d0a78.jpg";